module.exports = __webpack_public_path__ + "public/images/catalogue-stand-title.bfd2782f4dfcd97550aea89d12718341.svg";